import { Briefcase, MapPin, DollarSign, Heart, Zap, Coffee, Globe, Award } from 'lucide-react';
import './CompanyPages.css';

const CareersPage = () => {
  const benefits = [
    { icon: DollarSign, title: 'Competitive Salary', desc: 'Top-of-market compensation' },
    { icon: Globe, title: 'Remote First', desc: 'Work from anywhere in the world' },
    { icon: Heart, title: 'Health Coverage', desc: 'Comprehensive health benefits' },
    { icon: Zap, title: 'Learning Budget', desc: '$2000 annual learning stipend' },
    { icon: Coffee, title: 'Flexible Hours', desc: 'Work when you\'re most productive' },
    { icon: Award, title: 'Equity', desc: 'Stock options for all employees' },
  ];

  const openings = [
    { title: 'Senior Frontend Engineer', location: 'Remote', type: 'Full-time', dept: 'Engineering' },
    { title: 'Backend Developer', location: 'Remote', type: 'Full-time', dept: 'Engineering' },
    { title: 'Product Designer', location: 'Remote', type: 'Full-time', dept: 'Design' },
    { title: 'Customer Support Specialist', location: 'Remote', type: 'Full-time', dept: 'Support' },
    { title: 'Marketing Manager', location: 'Remote', type: 'Full-time', dept: 'Marketing' },
    { title: 'DevOps Engineer', location: 'Remote', type: 'Full-time', dept: 'Engineering' },
  ];

  return (
    <div className="company-page">
      <div className="company-bg">
        <div className="company-glow"></div>
      </div>

      <div className="company-container">
        {/* Hero */}
        <section className="company-hero">
          <div className="careers-badge">
            <Briefcase size={20} />
            <span>We&apos;re Hiring</span>
          </div>
          <h1 className="company-title">
            Join <span className="gradient-text">Our Team</span>
          </h1>
          <p className="company-subtitle">
            Help us build the future of cryptocurrency exchanges. 
            We&apos;re a remote-first team passionate about making crypto accessible to everyone.
          </p>
        </section>

        {/* Benefits */}
        <section className="benefits-section">
          <h2>Why Work With Us</h2>
          <div className="benefits-grid">
            {benefits.map((benefit, index) => (
              <div key={index} className="benefit-card" style={{ animationDelay: `${index * 0.1}s` }}>
                <benefit.icon size={28} />
                <h3>{benefit.title}</h3>
                <p>{benefit.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Open Positions */}
        <section className="openings-section">
          <h2>Open Positions</h2>
          <div className="openings-list">
            {openings.map((job, index) => (
              <div key={index} className="job-card" style={{ animationDelay: `${index * 0.1}s` }}>
                <div className="job-info">
                  <h3>{job.title}</h3>
                  <div className="job-meta">
                    <span><Briefcase size={14} /> {job.dept}</span>
                    <span><MapPin size={14} /> {job.location}</span>
                    <span className="job-type">{job.type}</span>
                  </div>
                </div>
                <button className="apply-btn">Apply Now</button>
              </div>
            ))}
          </div>
        </section>

        {/* Culture CTA */}
        <section className="culture-cta">
          <h2>Our Culture</h2>
          <p>
            We believe in transparency, innovation, and putting our users first. 
            Join a team that values your ideas and gives you the freedom to make an impact.
          </p>
          <button className="culture-btn">Learn More About Us</button>
        </section>
      </div>
    </div>
  );
};

export default CareersPage;
